import Cookies from 'js-cookie';

const domain = 'evertransit.com';

export default function setFirebaseCookieToken(customToken) {
    return Cookies.set('firebaseToken', customToken, { domain });
}
